import { FC, useState, useEffect } from "react";
import $device from "@/lib/device";
import OpenInBrowser from "@/components/OpenInBrowser";
import styles from "./index.module.scss";

interface IDownloadProps {
  onDownload?: () => void;
}

const Download: FC<IDownloadProps> = ({ onDownload }) => {
  const [isShowTip, setIsShowTip] = useState(false);
  useEffect(() => {
    if ($device.isWeChat) {
      setIsShowTip(true);
    }
  }, []);

  return (
    <div className={styles.page_container} style={{maxWidth: 412, position: 'relative'}}>
      <img src='https://static.hhocool.com/images/683a0e44-73ab-457f-9397-03545f409273_168x192.png' style={{width: 56, height: 64, position: 'absolute', right: 0, top: 56}} />
      <img src='https://static.hhocool.com/images/8abbf02c-6029-4913-910f-a4a0845b3024_150x207.png' style={{width: 56, height: 64, position: 'absolute', left: 0, top: 160}} />
      <img src='https://static.hhocool.com/images/683a0e44-73ab-457f-9397-03545f409273_168x192.png' style={{width: 56, height: 64, position: 'absolute', right: 0, top: 454}} />
      <header className={styles.header}>
        <img src='https://static.hhocool.com/images/0dcc0a84-f2db-434a-9d7b-9d6cc632b9a6_477x132.png' style={{width: 159, height: 44}} />
        <div className={styles.header_title}>1ポイント≈1円</div>
        <div className={styles.header_subtitle}>
          毎日ポイントがもらえる
        </div>
      </header>

      {/* main */}
      <main className={styles.main} style={{zIndex: 99}}>
        <div className={styles.download_wrap}>
          <img
            className={styles.app_capture_img}
            src="https://static.hhocool.com/images/a17d8aaf-b9db-445b-9ef2-becf62e5d715_783x1595.png"
            alt=""
          />

          <div className={styles.download_btn_wrap}>
            <button
              className={styles.download_btn}
              onClick={() => {
                onDownload && onDownload();
              }}
            >
              今すぐ体験する
            </button>
          </div>
        </div>
      </main>

      <OpenInBrowser visible={isShowTip} />
    </div>
  );
};

export default Download;
